module.exports = __webpack_public_path__ + "b35b290b8fba7288e6513b5e05916341.svg";